(function () {
  const MOBILE_QUERY = '(max-width: 749px)';
  const MOBILE_TEXT =
    'We use essential and analytics cookies to improve your experience.';
  const DESKTOP_TEXT =
    'We use essential cookies and optional analytics cookies to improve your experience.';
  const READ_MORE_LABEL = 'Read more';
  const PRIVACY_FALLBACK = '/policies/privacy-policy';

  let bannerObserver = null;
  let isUpdating = false;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getBanner() {
    return document.querySelector('#shopify-pc__banner');
  }

  function stopWatchingForBanner() {
    if (!bannerObserver) return;
    bannerObserver.disconnect();
    bannerObserver = null;
  }

  function getPolicyUrl(banner, paragraph) {
    const policyLink =
      paragraph.querySelector('a[href*="policy"]') || paragraph.querySelector('a');

    if (policyLink?.href) {
      banner.dataset.sscPolicyUrl = policyLink.href;
    }

    return banner.dataset.sscPolicyUrl || PRIVACY_FALLBACK;
  }

  function getButtonsContainer(banner) {
    return (
      banner.querySelector('.shopify-pc__banner__btns') ||
      banner.querySelector('.cookie-banner__buttons') ||
      banner.querySelector('[class*="banner__btns"]') ||
      banner.querySelector('[class*="button-group"]')
    );
  }

  function layoutDesktopBanner(banner) {
    if (isMobile()) return;

    const wrapper = banner.querySelector('.shopify-pc__banner__wrapper');
    const body = banner.querySelector('.shopify-pc__banner__body');
    const buttons = getButtonsContainer(banner);

    if (!wrapper || !body || !buttons) return;

    if (buttons.parentElement !== wrapper) {
      wrapper.appendChild(buttons);
    }

    if (body.compareDocumentPosition(buttons) & Node.DOCUMENT_POSITION_PRECEDING) {
      wrapper.insertBefore(body, buttons);
    }
  }

  function customizeBanner(banner) {
    const body = banner.querySelector('.shopify-pc__banner__body') || banner;
    const paragraph = body.querySelector('p');
    if (!paragraph) return;

    if (!banner.dataset.sscOriginalHtml) {
      banner.dataset.sscOriginalHtml = paragraph.innerHTML;
    }

    const mobile = isMobile();
    const text = mobile ? MOBILE_TEXT : DESKTOP_TEXT;
    const policyUrl = getPolicyUrl(banner, paragraph);
    const mode = mobile ? 'mobile' : 'desktop';

    if (banner.dataset.sscCustomized === mode) return;

    body.querySelector('.cookie-banner__read-more')?.remove();
    paragraph.textContent = text + ' ';

    const readMore = document.createElement('a');
    readMore.href = policyUrl;
    readMore.className = 'cookie-banner__read-more';
    readMore.textContent = READ_MORE_LABEL;
    readMore.setAttribute('rel', 'noopener');
    paragraph.appendChild(readMore);

    layoutDesktopBanner(banner);
    banner.dataset.sscCustomized = mode;
    stopWatchingForBanner();
  }

  function updateBanner() {
    if (isUpdating) return;
    isUpdating = true;

    try {
      const banner = getBanner();
      if (!banner) return;

      banner.dataset.sscCustomized = '';
      customizeBanner(banner);
    } finally {
      isUpdating = false;
    }
  }

  function watchForBanner() {
    if (bannerObserver || getBanner()) return;

    bannerObserver = new MutationObserver(() => {
      if (!getBanner()) return;
      updateBanner();
    });

    bannerObserver.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    updateBanner();
    watchForBanner();
    window.matchMedia(MOBILE_QUERY).addEventListener('change', updateBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
